<div class="logo-wrap">
  <ng-container *ngIf="isMobile; else isDesktop">
    <img *ngFor="let elem of [1,2,3,4,5]" src="assets/image/loading_login/{{elem}}.svg" class="icon -icon-{{elem}}" />
  </ng-container>
  <ng-template #isDesktop>
    <img *ngFor="let elem of [1,2,3,4,5,6,7,8,9,10]" src="assets/image/loading_login/{{elem}}.svg"
      class="icon -icon-{{elem}}" />
  </ng-template>
</div>
